import i18n from '@app/i18n';
import { APIError } from '@data';
import { antdNotification } from '@ui/components';

export const showDefaultErrorToast = (err: APIError) =>
  antdNotification.error({
    title: i18n.t(`beErrors.${err.response?.data?.message}`, {
      defaultValue: i18n.t('beErrors.unexpectedError'),
    }),
    description: i18n.t(`beErrors.${err.response?.data?.message}_description`, {
      defaultValue: '',
    }),
  });
